function EventCtrl($scope, $state, $stateParams, $q, sdkVenueService, eventService, sdkUtils, dateUtilsService, alertService, managementUserService, ERROR_MESSAGES, organizationService, mapperService, venueService, urlService) { //eslint-disable-line
  const vm = this;

  vm.loading = true;
  vm.venueId = $stateParams.venueId;

  $scope.venuePromise = _getVenue();
  $scope.eventPromise = _getEvent();

  $scope.$on('EVENT_UPDATED', (event, updatedEvent) => {
    $scope.eventPromise = $q.resolve(updatedEvent);
  });

  const dataPromises = [
    $scope.venuePromise,
    $scope.eventPromise
  ];

  //open the correct sub nav accoridon
  if ($state.current.name === 'app.organization.event.widgets' ||
    $state.current.name === 'app.organization.event.widget' ||
    $state.current.name === 'app.organization.event.promoterLinks') {
    vm.showSalesToolsLinks = true;
  }

  $q.all(dataPromises)
    .then(results => {
      vm.venue = results[0];
      vm.event = results[1];

      const mappedEvent = mapperService.mapEventToUI(results[1]);

      const seoPathname = (mappedEvent.seoPathname) ? mappedEvent.seoPathname : mappedEvent.id;

      mappedEvent.publicPageURL = urlService.getEventPublicPageUrl(seoPathname, {});

      vm.eventForm = mappedEvent;

      vm.loading = false;
    });

  // ----------------------- private helpers ----------------------- //

  function _getEvent() {
    return eventService.readById($stateParams.eventId)
      .catch(() => {
        alertService.success('Sorry, we ran into issues getting your event.');

        $state.go('404');
      });
  }

  function _getVenue() {
    return sdkVenueService.readById($stateParams.venueId)
      .catch(() => {
        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_VENUES);
      });
  }
}

EventCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService'
];

export default EventCtrl;



// WEBPACK FOOTER //
// ./src/components/event/eventCtrl.js